window.addEventListener("DOMContentLoaded", () => {
  const parentElement = document.body; // Use a parent element that contains your buttons and swatches

  // Event delegation for quickbuy buttons
  parentElement.addEventListener("click", (e) => {
    if (e.target.classList.contains("custom-mobile-quickbuy-btn")) {
      const nextSibling = e.target.nextElementSibling;
      if (nextSibling && nextSibling.classList.contains("custom-mobile-quickbuy-reveal")) {
        nextSibling.classList.remove("custom-mobile-quickbuy-reveal");
      } else if (nextSibling) {
        nextSibling.classList.add("custom-mobile-quickbuy-reveal");
      }
    }
  });

  // Event delegation for quickbuy swatches
  parentElement.addEventListener("click", async (e) => {
    if (e.target.classList.contains("custom-mobile-quickbuy-size-swatch")) {
      const variantId = e.target.getAttribute("variant-id");
      if (!variantId) return;

      const formData = {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      };

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        const data = await response.json();
        console.log("data", data);

        document.dispatchEvent(
          new CustomEvent("theme:cartchanged", {
            bubbles: true,
            cancelable: false,
            detail: { preventVariantUpdate: true },
          })
        );

        document.dispatchEvent(
          new CustomEvent("theme:open-cart-drawer", { bubbles: true, cancelable: false })
        );
      } catch (error) {
        console.error("Error adding item to cart:", error);
      }
    }
  });
});
